import React from 'react'
import NextStep from './NextStep'
import CHANNEL_NextStep from './CHANNEL_NextStep'
import AvailableMethods from '../Components/AvailableMethods'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import BankSelect from '../Components/BankSelect'
import TipsView from '../Components/TipsView'
import SubmitBtn from '../Components/SubmitBtn'
import Modal from "../Components/Modal";
import CTCCon from '$Deposits/Components/CTC'
import CTCTutorialModal from '../Components/CTCTutorialModal'
import { connect } from 'react-redux'
import { GetParamsData } from '$Deposits/lib/LibCommonData'

class CTC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tutorialVisible: false,
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { MethodCodeActive, DepositSuccessPage } = this.props
        const { webPiwikEvent } = GetParamsData()

        return (
            <>
                <div className='methodsActive CTCMethod'>
                    {!DepositSuccessPage &&
                        <>
                            <div 
                                className='depositTutorialButton' 
                                onClick={() => { 
                                    webPiwikEvent("Deposit", "View Tutorial", "Deposit_Crpto_V_Tutorial")
                                    this.setState({ tutorialVisible: true }) 
                                }}
                            >
                                <span data-CN="存款流程">ขั้นตอนการฝาก</span>
                            </div>
                            <CTCTutorialModal
                                visible={this.state.tutorialVisible}
                                method={MethodCodeActive}
                                onClose={()=>{this.setState({tutorialVisible:false})}}
                            />
                        </>
                    }
                    <CTCCon
                        Modal={(propCon) => {
                            const { modalVisible, code, onChange, MethodCodeActive, onCancel } = propCon
                            return (
                                <Modal
                                    className='modalTips CTCModal'
                                    visible={modalVisible}
                                    title='แจ้งเตือน'
                                    okText='ยืนยัน'
                                    onOk={onChange}
                                    cancelText="ปิด"
                                    onCancel={onCancel}
                                >
                                    <>
                                        {
                                            MethodCodeActive == 'INVOICE' &&
                                            <>
                                                <div className='titleIcon'>
                                                    <span className={'USDT-ERC20Icon CTCimgIcon'} />
                                                    <span>Tether USD (USDT-ERC20)</span>
                                                </div>
                                                <p className="intro introBlue left">
                                                    กรุณาโอนเงินจำนวน USDT-ERC20 + ค่าธรรมเนียม <br /> การทำธุรกรรม
                                                </p>
                                                <p className="intro left">
                                                    ตัวอย่าง ค่าธรรมเนียมของ Huobi คือ 3 USDT หากทำ<br/>
                                                    รายการฝากยอดเท่ากับ 15.88 USDT ยอดโอนทั้งหมด<br/>
                                                    จะต้องเป็นยอด 18.88 USDT
                                                </p>
                                            </>
                                        }
                                        {
                                            MethodCodeActive == 'CHANNEL' &&
                                            <>
                                                <div className='titleIcon'>
                                                    <span className={code + 'Icon CTCimgIcon'} />
                                                    <span>Tether USD ({code})</span>
                                                </div>
                                                <p className="intro introBlue left">
                                                    กรุณาโอนเฉพาะ {code} ไปยังที่อยู่กระเป๋าเงิน<br /> ในขั้นตอนต่อไป การโอนเหรียญอื่นๆ อาจส่งผลให้เงินฝาก<br /> ของคุณสูญหาย
                                                </p>
                                                <p className="intro left">
                                                    เมื่อคลิกปุ่ม “ยืนยัน” แสดงว่าคุณยอมรับความเสี่ยง ดังกล่าว
                                                </p>
                                            </>
                                        }

                                    </>
                                </Modal>
                            )
                        }}
                        TipsView={TipsView}
                        AvailableMethods={AvailableMethods}
                        MoneyInput={MoneyInput}
                        BankSelect={BankSelect}
                        SubmitBtn={SubmitBtn}
                        NextStep={NextStep}
                        CHANNEL_NextStep={CHANNEL_NextStep}
                        SuccessPage={SuccessPage}

                    />
                </div>
            </>
        );
    }
}


const mapStateToProps = state => ({
    MethodCodeActive: state.MethodCodeActive,
    DepositSuccessPage: state.DepositSuccessPage,
});

export default connect(mapStateToProps)(CTC)



